import { render } from "./legoProgressMask.vue?vue&type=template&id=877c6eb8"
import script from "./legoProgressMask.vue?vue&type=script&lang=js"
export * from "./legoProgressMask.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoProgress/legoProgressMask.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "877c6eb8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('877c6eb8', __exports__)) {
    api.reload('877c6eb8', __exports__)
  }
  
  module.hot.accept("./legoProgressMask.vue?vue&type=template&id=877c6eb8", () => {
    api.rerender('877c6eb8', render)
  })

}


export default __exports__